<template>
  <div id="appmain" @contextmenu.prevent>
	<div class="smvContainer" id="smv_Main" cpid="30536" style="min-height:400px;width:1200px;height:820px;  position: relative; ">
	<div id="smv_con_1_44" ctype="slideset"  class="esmartMargin smartAbs " cpid="30536" cstyle="Style1" ccolor="Item0" areaId="" isContainer="True" pvid="" tareaId=""  re-direction="y" daxis="Y" isdeletable="True" style="height: 800px; width: 100%; left: 0px; top: 0px;z-index:2;">
	<div class="yibuFrameContent con_1_44  slideset_Style1  " style="overflow:visible;;" >
	<div id="lider_smv_con_1_44_wrapper">
	<div class="w-slide" id="slider_smv_con_1_44">
	<div class="w-slide-inner" data-u="slides">
	<div class="content-box" data-area="Area0">
	<div id="smc_Area0" cid="con_1_44" class="smAreaC slideset_AreaC">
	
	<!--文字开始-->
	<!--
	<div id="smv_con_8_28" ctype="text"  class="esmartMargin smartAbs " cpid="30536" cstyle="Style1" ccolor="Item0" areaId="Area0" isContainer="False" pvid="con_1_44" tareaId=""  re-direction="all" daxis="All" isdeletable="True" style="height: 129px; width: 622px; left: 111px; top: 252px;z-index:2;">
	<div class="yibuFrameContent con_8_28  text_Style1  " style="overflow:hidden;;" >
	<div id='txt_con_8_28' style="height: 100%;">
	<div class="editableContent" id="txtc_con_8_28" style="height: 100%; word-wrap:break-word;">
		<p><span style="color:#333333"><span style="line-height:1.2"><span style="font-family:&quot;Source Han Sans&quot;"><span style="font-size:54px"><strong>专注</strong></span></span></span></span></p>
	<p><span style="color:#333333"><span style="line-height:1.2"><span style="font-family:&quot;Source Han Sans&quot;"><span style="font-size:54px"><strong>养老机器人的</strong></span></span></span></span><span style="color:#333333"><span style="line-height:1.2"><span style="font-family:&quot;Source Han Sans&quot;"><span style="font-size:54px"><strong>研发制作</strong></span></span></span></span></p>
	<p>&nbsp;</p>
	</div>
	</div>
	</div>
	</div>

	<div id="smv_con_11_39" ctype="text"  class="esmartMargin smartAbs " cpid="30536" cstyle="Style1" ccolor="Item4" areaId="Area0" isContainer="False" pvid="con_1_44" tareaId=""  re-direction="all" daxis="All" isdeletable="True" style="height: 56px; width: 455px; left: 111px; top: 400px;z-index:5;">
	<div class="yibuFrameContent con_11_39  text_Style1  " style="overflow:hidden;;" >
	<div id='txt_con_11_39' style="height: 100%;">
	<div class="editableContent" id="txtc_con_11_39" style="height: 100%; word-wrap:break-word;">
		<p><span style="color:#000000"><span style="font-size:16px"><span style="font-family:Source Han Sans,Geneva,sans-serif">展现无人机的科技之美，稳定飞行，高效实现目标</span></span></span></p>

	</div>
	</div>
	</div>
	</div>
	-->
	<!--文字结束-->

	<div id="smv_con_12_35" ctype="button"  class="esmartMargin smartAbs " cpid="30536" cstyle="Style9" ccolor="Item0" areaId="Area0" isContainer="False" pvid="con_1_44" tareaId=""  re-direction="all" daxis="All" isdeletable="True" style="height: 47px; width: 183px; left: 1011px; top: 660px;z-index:6;">
	<div class="yibuFrameContent con_12_35  button_Style9  " style="overflow:visible;;" >
		<a target="_self" href="/product" class="w-button w-isi-left w-button-isi f-ellipsis hover-effect" data-effect-name="forward" style="width: 183px; height: 47px; line-height: 47px;">
		<span class="w-button-position">
		<span class="w-button-position-inner">
		<em class="w-button-text f-ellipsis">
		<i class="mw-iconfont w-button-icon w-icon-hide"></i>
		了解我们的产品
		</em>
		</span>
		</span>
		</a>
	</div>
	</div>

	<div id="smv_con_12_35" ctype="button"  class="esmartMargin smartAbs " cpid="30536" cstyle="Style9" ccolor="Item0" areaId="Area0" isContainer="False" pvid="con_1_44" tareaId=""  re-direction="all" daxis="All" isdeletable="True" style="height: 10px; width: 10px; left: 680px; top: 765px;z-index:6;">
	<div class="yibuFrameContent con_12_35  button_Style9" style="overflow:visible;" >
		<a target="_self" href="javascript:;" style="width: 15px; height: 15px; line-height: 15px;" :style="{ color: dynamicLinkColor2 }" @click="changeColor2">
		●
		</a>
	</div>
	</div>

	<div id="smv_con_12_35" ctype="button"  class="esmartMargin smartAbs " cpid="30536" cstyle="Style9" ccolor="Item0" areaId="Area0" isContainer="False" pvid="con_1_44" tareaId=""  re-direction="all" daxis="All" isdeletable="True" style="height: 10px; width: 10px; left: 660px; top: 765px;z-index:6;">
	<div class="yibuFrameContent con_12_35  button_Style9  " style="overflow:visible;;" >
		<a target="_self" href="javascript:;" style="width: 15px; height: 15px; line-height: 15px;" :style="{ color: dynamicLinkColor1 }" @click="changeColor1">
		●
		</a>
	</div>
	</div>

	<div id="smv_con_12_35" ctype="button"  class="esmartMargin smartAbs " cpid="30536" cstyle="Style9" ccolor="Item0" areaId="Area0" isContainer="False" pvid="con_1_44" tareaId=""  re-direction="all" daxis="All" isdeletable="True" style="height: 10px; width: 10px; left: 640px; top: 765px;z-index:6;">
	<div class="yibuFrameContent con_12_35  button_Style9  " style="overflow:visible;;" >
		<a target="_self" href="javascript:;" style="width: 15px; height: 15px; line-height: 15px;" :style="{ color: dynamicLinkColor0 }" @click="changeColor0">
		●
		</a>
	</div>
	</div>

	</div>
		<div id="bgImg"  class="content-box-inner" style="background-size: cover;background-repeat:no-repeat;background-position: center;;background-color:#ffffff;opacity:1" :style="backgroundStyle">
		</div>
	</div>
	</div>
	</div>
	</div>
	</div>
	</div>
	</div>
	<!--
	<div id="txtc_con_40_34" style="height: 100%; word-wrap:break-word;">
	<p style="text-align:center"><span style="color:#333333"><span style="font-size:32px"><span style="line-height:1.5"><span style="font-family:Microsoft JhengHei"><strong>我们让无人机稳定飞行，高效实现目标。</strong></span></span></span></span></p>

	<p style="text-align:center"><span style="color:#333333"><span style="font-size:32px"><span style="line-height:1.5"><span style="font-family:Microsoft JhengHei"><strong>专注无人机的研发制作，展现无人机的科技之美。</strong></span></span></span></span></p>
	<p style="text-align:center"></p>
	</div>
	
	<div class="yibuFrameContent con_41_48  button_Style9  " style="overflow:visible;;" >
	<br>

	
	<a target="_self" href="/about" class="w-button w-isi-left w-button-isi f-ellipsis hover-effect" data-effect-name="forward" style="width: 182px; height: 45px; line-height: 45px;">
	    <span class="w-button-position">
		<span class="w-button-position-inner">
		    <em class="w-button-text f-ellipsis">
			<i class="mw-iconfont w-button-icon w-icon-hide"></i>
			了解我们
		    </em>
		</span>
	    </span>
	</a>
	
	</div>
	-->
	<div style="position: relative; justify-content: center;">
	<img src='/image/home2.png' style="width:100%">
	</div>
  </div>
</template>

<script>
export default {
  name: 'appmain',
  data() {
    return {
      //bg: {backgroundImage: "url(" + ("./image/home_2.png") + ")"},
      dynamicLinkColor0: '#CCCCCC',
      dynamicLinkColor1: '#CCCCCC',
      dynamicLinkColor2: '#CCCCCC',
      images: ["./image/home_1.png", "./image/home_2.png", "./image/home_3.png"],
      //intervalId: null
       currentIndex: 0

    };
  },
  computed: {
    changeColor0() {
      this.currentIndex = 0;
      backgroundImage: `url(${this.currentImage})`;
    },
    changeColor1() {
      this.currentIndex = 1;
      backgroundImage: `url(${this.currentImage})`;
    },
    changeColor2() {
      this.currentIndex = 2;
      backgroundImage: `url(${this.currentImage})`;
    },
    backgroundStyle() {
      return {
        backgroundImage: `url(${this.currentImage})`
      };
    },
    currentImage() {
      //console.log("this.currentIndex",this.currentIndex);
      this.dynamicLinkColor0 = '#CCCCCC';
      this.dynamicLinkColor1 = '#CCCCCC';
      this.dynamicLinkColor2 = '#CCCCCC';
      switch(this.currentIndex){
	case 0:
		this.dynamicLinkColor0 = '#1E90FF';
		break;
	case 1:
		this.dynamicLinkColor1 = '#1E90FF';
		break;
	case 2:
		this.dynamicLinkColor2 = '#1E90FF';
		break;
	default:
		break;
      }
      return this.images[this.currentIndex];
    },
    nextIndex() {
      return (this.currentIndex + 1) % this.images.length;
    }
  },
  mounted() {
    setInterval(() => {
      this.currentIndex = this.nextIndex;
    }, 5000);
  }
};
</script>

<style>

</style>
